import { memo } from "react";
import PropTypes from "prop-types";
import BadgeList from "app/pages/.shared/ColoredProductBadge/BadgeList";
import "./ProductTopBar.scss";
import FavoriteBadge from "app/pages/.shared/FavoriteBadge/FavoriteBadge";

const ProductTopBar = ({ badges = [], isFavorite }) => {
	return (
		<div className="product-top-bar" data-testid="product-top-bar">
			<div className="product-top-bar__badges">
				{badges.length > 0 && <BadgeList badges={badges} />}

				{isFavorite && <FavoriteBadge />}
			</div>
		</div>
	);
};

ProductTopBar.propTypes = {
	isFavorite: PropTypes.bool,
	badges: PropTypes.array,
};

export default memo(ProductTopBar);
